import { pushStorefrontDataToDatalayer } from '../../analytics/storefront'
import { State, StorefrontData, StorefrontState } from '../../../types'

export const FETCH_STOREFRONT_PENDING = 'storefront//FETCH_STOREFRONT_PENDING'
export const FETCH_STOREFRONT_DONE = 'storefront//FETCH_STOREFRONT_DONE'
export const FETCH_STOREFRONT_ERROR = 'storefront//FETCH_STOREFRONT_ERROR'

export interface FetchStorefrontPendingAction {
  type: typeof FETCH_STOREFRONT_PENDING
  payload: Record<string, never>
}

export interface FetchStorefrontDoneAction {
  type: typeof FETCH_STOREFRONT_DONE
  payload: { data: StorefrontData }
}

export interface FetchStorefrontErrorAction {
  type: typeof FETCH_STOREFRONT_ERROR
  payload: { err: unknown }
}

export type StorefrontAction =
  | FetchStorefrontPendingAction
  | FetchStorefrontDoneAction
  | FetchStorefrontErrorAction

export function pending(): FetchStorefrontPendingAction {
  return {
    type: FETCH_STOREFRONT_PENDING,
    payload: {},
  }
}

export function done(data: StorefrontData): FetchStorefrontDoneAction {
  pushStorefrontDataToDatalayer(data)
  return {
    type: FETCH_STOREFRONT_DONE,
    payload: { data },
  }
}

export function error(err: unknown): FetchStorefrontErrorAction {
  return {
    type: FETCH_STOREFRONT_ERROR,
    payload: { err },
  }
}

export function getStep(store: State) {
  return store.storefront.data?.custom?.formSection
}

export function getOfferExpiration(store: State) {
  return store.storefront.data?.custom?.offer?.validityEndDate
}

export function getStorefrontData(store: State) {
  return store.storefront.data
}

const initialState: StorefrontState = {
  pending: false,
  data: {} as StorefrontData,
  error: null,
}

export default function storefrontReducer(
  state: StorefrontState = initialState,
  action: StorefrontAction
): StorefrontState {
  switch (action.type) {
    case FETCH_STOREFRONT_PENDING:
      return {
        ...state,
        data: {} as StorefrontData,
        pending: true,
        error: null,
      }

    case FETCH_STOREFRONT_DONE:
      return {
        ...state,
        data: action.payload.data,
        pending: false,
        error: null,
      }
    case FETCH_STOREFRONT_ERROR:
      return {
        ...state,
        data: {} as StorefrontData,
        pending: false,
        error: true,
      }

    default:
      return state
  }
}
